import script from "./UserRelations.vue?vue&type=script&setup=true&lang=js"
export * from "./UserRelations.vue?vue&type=script&setup=true&lang=js"

import "./UserRelations.vue?vue&type=style&index=0&id=d8c81eec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d8c81eec"]])

export default __exports__